/** Stable ids for new records. crypto.randomUUID is available in every browser
    that supports the rest of the stack. */
export function newId(prefix: string): string {
  return `${prefix}-${crypto.randomUUID()}`;
}
